import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { LeftOutlined, ReloadOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Divider,
  Form,
  Row,
  Spin,
  Statistic,
  Table,
  Typography,
} from "antd";

//PROJECT IMPORTS
import { connect, useDispatch } from "react-redux";
import DownloadTableButtons from "../../../../../../components/DownloadTableButtons";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../components/layouts/TopContent";
import { rightAction } from "../../../../../../redux/actions";
import cnt from "../../../../../../services/definedConstant";
import { BOM } from "../../../../../../services/definedMethod";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import FixedAccSearchJournalEntries from "./FixedAccSearchJournalEntries";

const { Text, Title } = Typography;

const columns = [
  {
    title: "Entry ID",
    dataIndex: "id",
  },
  {
    title: "Branch",
    dataIndex: "branch",
    sorter: (a, b) => a.branch.localeCompare(b.branch),
  },
  {
    title: "Transaction Date",
    dataIndex: "transactionDate",
    sorter: (a, b) => a.transactionDate.localeCompare(b.transactionDate),
  },
  {
    title: "Transaction Tag",
    dataIndex: "transactionTag",
  },
  {
    title: "Transaction ID",
    dataIndex: "transactionId",
  },
  {
    title: "Account",
    dataIndex: "account",
    sorter: (a, b) => a.account.localeCompare(b.account),
  },
  {
    title: "Amount",
    dataIndex: "amount",
  },
];

const FixedAccManageJournalEntries = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const navigate = useNavigate();
  const { state } = useLocation();
  const { session } = userData;
  const [journalEntryList, setJournalEntryList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const dispatch = useDispatch();
  const [useForm] = Form.useForm();

  useEffect(() => {
    getJournalEntryListAction(state);
  }, []);

  const getJournalEntryListAction = (state) => {
    const params = {
      dateFormat: "dd MMMM yyyy",
      limit: 14,
      locale: "en",
      offset: 0,
      savingsId: state.id,
    };
    const url = `${apiConfig.JournalEntries}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res.pageItems;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id ? element?.id : "-",
            branch: element?.officeName ? element?.officeName : "-",
            transactionDate: element?.transactionDate
              ? BOM.FormatArrayDate(element?.transactionDate)
              : "-",
            transactionId: element?.transactionId
              ? element?.transactionId
              : "-",
            type: element?.glAccountType?.value
              ? element?.glAccountType?.value
              : "-",
            createdBy: element?.createdByUserName
              ? element?.createdByUserName
              : "-",
            account: element?.glAccountName
              ? `${element?.glAccountName} (${element?.glAccountCode})`
              : "-",
            transactionTag: element?.entryType?.value
              ? element?.entryType?.value === "DEBIT"
                ? "Dr"
                : element?.entryType?.value === "CREDIT"
                  ? "Cr"
                  : "-"
              : "-",
            amount: element?.amount ? (
              <Statistic
                value={element?.amount}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ) : (
              "-"
            ),
            amountToUse: element?.amount ? element?.amount : 0,
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setJournalEntryList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        dateFormat: "dd MMMM yyyy",
        limit: 1000,
        offset: 0,
        locale: "en",
        savingsId: state.id,
      };
      const url = `${apiConfig.JournalEntries}`;

      let body = {
        session,
        params,
      };

      setIsLoading(true);

      BOM.FetchReqAction(body, url, (err, res) => {
        if (err) {
          reject(err);
        } else {
          setIsLoading(false);

          const objList = res.pageItems;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id ? element?.id : "-",
              branch: element?.officeName ? element?.officeName : "-",
              transactionDate: element?.transactionDate
                ? BOM.FormatArrayDate(element?.transactionDate)
                : "-",
              transactionId: element?.transactionId
                ? element?.transactionId
                : "-",
              type: element?.glAccountType?.value
                ? element?.glAccountType?.value
                : "-",
              createdBy: element?.createdByUserName
                ? element?.createdByUserName
                : "-",
              account: element?.glAccountName
                ? `${element?.glAccountName} (${element?.glAccountCode})`
                : "-",
              transactionTag: element?.entryType?.value
                ? element?.entryType?.value === "DEBIT"
                  ? "Dr"
                  : element?.entryType?.value === "CREDIT"
                    ? "Cr"
                    : "-"
                : "-",
              amount: element?.amount ? element?.amount : "-",
              amountToUse: element?.amount ? element?.amount : 0,
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  //DECLARED METHODS
  const onRefresh = () => {
    useForm.resetFields();
    getJournalEntryListAction(state);
  };

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  function handleOnView() {
    // console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-fixed-journal-entries", {
        state: { ...state, transactionId: selectedRow.transactionId },
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function backOnClick() {
    navigate("/detail-fixed-deposit-account", { state: state });
  }

  return (
    <MainLayout isEnableRightSidebar={true} onView={handleOnView}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.journalEntries}
        pageItems={staticConfig.journalEntriesBreadcrumbItems}
      />
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
        title={
          <Row
            style={{
              alignContent: "center",
              //   width: "8%",
            }}
          >
            <Button
              icon={<LeftOutlined />}
              type="text"
              style={{
                marginTop: "auto",
                marginBottom: "auto",
              }}
              onClick={backOnClick}
            >
              <Text
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  fontSize: 15,
                }}
              >
                Back
              </Text>
            </Button>
          </Row>
        }
      >
        <Spin spinning={isLoading} size="large">
          <Row>
            <Row style={{ marginBottom: 20 }}>
              <FixedAccSearchJournalEntries
                currentAccountObj={state}
                journalEntryList={journalEntryList}
                setJournalEntryList={setJournalEntryList}
              />
              <Button
                type="primary"
                shape="round"
                className="of-primaryBtnColor"
                onClick={onRefresh}
                icon={<ReloadOutlined />}
                loading={isLoading}
                style={{
                  marginLeft: 10,
                  marginBottom: "auto",
                }}
              >
                {labelConfig.refresh}
              </Button>
              {/* <DownloadTableButtons
                downloadData={journalEntryList}
                columns={columns}
                fileName={"Journal Entry List"}
              /> */}
            </Row>
            {/* <DownloadTableButtons
              downloadData={journalEntryList}
              columns={columns}
              fileName={"Fixed Account Journal Entry List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Divider />
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={journalEntryList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FixedAccManageJournalEntries);
